import { render, staticRenderFns } from "./Visit-Extend.vue?vue&type=template&id=5676fad7"
import script from "./Visit-Extend.vue?vue&type=script&lang=js"
export * from "./Visit-Extend.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports